"use strict";

var _Reflect$construct = require("@babel/runtime-corejs3/core-js-stable/reflect/construct");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactUiTheming = require("@concur/react-ui-theming");
var _shortId = _interopRequireDefault(require("../utils/shortId"));
var _focusManager = _interopRequireDefault(require("../utils/focusManager"));
var _StyleConfig = require("../utils/StyleConfig");
var _SpinnerConcur_android = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Spinner-concur_android.css") : void 0);
var _SpinnerConcur_default = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Spinner-concur_default.css") : void 0);
var _SpinnerConcur_gateway = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Spinner-concur_gateway.css") : void 0);
var _SpinnerConcur_ios = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Spinner-concur_ios.css") : void 0);
var _SpinnerSap_fiori_3_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Spinner-sap_fiori_3_dark.css") : void 0);
var _SpinnerSap_fiori_3_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Spinner-sap_fiori_3_hcb.css") : void 0);
var _SpinnerSap_fiori_3_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Spinner-sap_fiori_3_hcw.css") : void 0);
var _SpinnerSap_fiori_ = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Spinner-sap_fiori_3.css") : void 0);
var _SpinnerSap_horizon_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Spinner-sap_horizon_dark.css") : void 0);
var _SpinnerSap_horizon_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Spinner-sap_horizon_hcb.css") : void 0);
var _SpinnerSap_horizon_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Spinner-sap_horizon_hcw.css") : void 0);
var _SpinnerSap_horizon = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Spinner-sap_horizon.css") : void 0);
var _excluded = ["boxClassName", "className", "classNameMap", "content", "contentClassName", "hideMessage", "id", "inverted", "maskColor", "message", "messageClassName", "messageContainerClassName", "type", "visible", "wheelClassName"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var styles = {
  concur_android: _SpinnerConcur_android.default,
  concur_default: _SpinnerConcur_default.default,
  concur_gateway: _SpinnerConcur_gateway.default,
  concur_ios: _SpinnerConcur_ios.default,
  sap_fiori_3_dark: _SpinnerSap_fiori_3_dark.default,
  sap_fiori_3_hcb: _SpinnerSap_fiori_3_hcb.default,
  sap_fiori_3_hcw: _SpinnerSap_fiori_3_hcw.default,
  sap_fiori_3: _SpinnerSap_fiori_.default,
  sap_horizon_dark: _SpinnerSap_horizon_dark.default,
  sap_horizon_hcb: _SpinnerSap_horizon_hcb.default,
  sap_horizon_hcw: _SpinnerSap_horizon_hcw.default,
  sap_horizon: _SpinnerSap_horizon.default
};
(0, _freeze.default)(styles);
var MASK_COLORS = ['gray', 'white'];
var CSS_BLOCK = 'sapcnqr-spinner';
var WHEEL_CSS_ELEMENT = "".concat(CSS_BLOCK, "__wheel");

/**
 * The **Spinner** component provides feedback to a user during the loading of
 * another component or page.
 *
 * In order for this component to be used with the included mask, it must be
 * placed inside an HTML element that is relatively positioned. The
 * `.cnqr-position-relative` CSS class can be used to set relative positioning
 * on any element. For example, the **Spinner** might be inside an application’s
 * parent HTML container or inside a section on the page.
 *
 * > When using Full Page and Full Screen **Spinner** components, the top level element
 * that the spinner is overlaying must contain the attribute `inert="true"` in
 * order for content to be invisible to the accessibility tree. When the **Spinner**
 * is no longer being used to overlay any elements, `inert="false"` should
 * be set to the element which previously contained the attribute so that any
 * elements that were invisible to the accessibility tree will now be visible.
 * By using this attribute, keyboard navigation and speech output will be disabled
 * to underlying elements while **Spinner** is active and will avoid confusion to sight
 * impaired users and keyboard navigation users that inaccessible/invisible elements
 * are present on the page. See [MDN](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/inert)
 * for more information as to how to use the `inert` attribute.
 *
 * > Note: Using the `inert` property on a Typescript React app has some issues. See examples on how
 * to pass `inert` so that the property makes it to the DOM. See this inert
 * [issue](https://github.com/WICG/inert/issues/58#issuecomment-618016847).
 */
var Spinner = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Spinner, _React$Component);
  var _super = _createSuper(Spinner);
  function Spinner(props) {
    var _this;
    (0, _classCallCheck2.default)(this, Spinner);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_handleFocusManager", function (isFullScreen) {
      var visible = _this.props.visible;
      if (isFullScreen && visible && _this.spinner) {
        _this._focusManager = new _focusManager.default({
          trapNode: _this.spinner
        });
      }
    });
    _this.shortId = _shortId.default.generate();
    return _this;
  }
  (0, _createClass2.default)(Spinner, [{
    key: "_getSpinnerSize",
    value: function _getSpinnerSize(isInline, isFullScreen, isFullPage) {
      var size = this.props.size;
      if (isFullPage || isFullScreen) {
        return "".concat(WHEEL_CSS_ELEMENT, "--fullPage");
      }
      if (isInline) {
        return "".concat(WHEEL_CSS_ELEMENT, "--inline-").concat(size);
      }
      return "".concat(WHEEL_CSS_ELEMENT, "--").concat(size);
    }
  }, {
    key: "_renderSpinner",
    value: function _renderSpinner(classnames, isInline, isFullScreen, isFullPage) {
      var wheelClassName = this.props.wheelClassName;
      var classNames = classnames(wheelClassName, this._getSpinnerSize(isInline, isFullScreen, isFullPage), WHEEL_CSS_ELEMENT);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classNames
      }, /*#__PURE__*/_react.default.createElement("svg", {
        "aria-hidden": true,
        className: classnames("".concat(CSS_BLOCK, "__shape")),
        viewBox: "25 25 50 50"
      }, /*#__PURE__*/_react.default.createElement("circle", {
        className: classnames("".concat(CSS_BLOCK, "__shape--background")),
        cx: "50",
        cy: "50",
        fill: "none",
        r: "20",
        strokeMiterlimit: "10"
      }), /*#__PURE__*/_react.default.createElement("circle", {
        className: classnames("".concat(CSS_BLOCK, "__shape--indicator")),
        cx: "50",
        cy: "50",
        fill: "none",
        r: "20",
        strokeMiterlimit: "10"
      })));
    }
  }, {
    key: "_renderMessaging",
    value: function _renderMessaging(classnames, message, isInline, hideMessage, isFullPage, isFullScreen) {
      var _this$props = this.props,
        id = _this$props.id,
        messageClassName = _this$props.messageClassName,
        messageContainerClassName = _this$props.messageContainerClassName,
        size = _this$props.size;
      var textSize = '';
      if (isInline) {
        if (size === 'lg') {
          textSize = "".concat(CSS_BLOCK, "__message-inline--large");
        }
      } else if (isFullPage || isFullScreen) {
        textSize = "".concat(CSS_BLOCK, "__message--large");
      } else if (size === 'lg') {
        textSize = "".concat(CSS_BLOCK, "__message--small");
      }
      var messageContainerClassNames = classnames("".concat(CSS_BLOCK, "__message-box"), messageContainerClassName, (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__message-box--screen-reader-only"), hideMessage));
      var paragraphClassNames = classnames("".concat(CSS_BLOCK, "__message"), textSize, messageClassName, (0, _defineProperty2.default)({}, "".concat(CSS_BLOCK, "__message-inline"), isInline));
      return /*#__PURE__*/_react.default.createElement("div", {
        className: messageContainerClassNames
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: paragraphClassNames,
        id: "".concat(id || this.shortId, "-message")
      }, message));
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames3,
        _classnames4,
        _this2 = this;
      var _this$props2 = this.props,
        boxClassName = _this$props2.boxClassName,
        className = _this$props2.className,
        classNameMap = _this$props2.classNameMap,
        content = _this$props2.content,
        contentClassName = _this$props2.contentClassName,
        hideMessage = _this$props2.hideMessage,
        id = _this$props2.id,
        inverted = _this$props2.inverted,
        maskColor = _this$props2.maskColor,
        message = _this$props2.message,
        messageClassName = _this$props2.messageClassName,
        messageContainerClassName = _this$props2.messageContainerClassName,
        type = _this$props2.type,
        visible = _this$props2.visible,
        wheelClassName = _this$props2.wheelClassName,
        otherProps = (0, _objectWithoutProperties2.default)(_this$props2, _excluded);
      if (!visible) {
        return null;
      }
      var classnames = _bind.default.bind(classNameMap);
      var isFullPage = type === 'fullPage';
      var isFullScreen = type === 'fullScreen';
      var isInline = type === 'inline';
      var isBlock = type === 'block';
      var classes = classnames(CSS_BLOCK, className, (_classnames3 = {}, (0, _defineProperty2.default)(_classnames3, "".concat(CSS_BLOCK, "__mask"), !isInline && !isBlock), (0, _defineProperty2.default)(_classnames3, "".concat(CSS_BLOCK, "__mask--").concat(maskColor), !inverted && !isBlock && !isInline), (0, _defineProperty2.default)(_classnames3, "".concat(CSS_BLOCK, "__mask--secondary"), inverted), (0, _defineProperty2.default)(_classnames3, "".concat(CSS_BLOCK, "__mask--full-page"), isFullPage), (0, _defineProperty2.default)(_classnames3, "".concat(CSS_BLOCK, "__mask--full-screen"), isFullScreen), (0, _defineProperty2.default)(_classnames3, "".concat(CSS_BLOCK, "--inverted"), inverted), (0, _defineProperty2.default)(_classnames3, "".concat(CSS_BLOCK, "--inline"), isInline), (0, _defineProperty2.default)(_classnames3, "".concat(CSS_BLOCK, "--block"), isBlock), _classnames3));
      var spinnerBoxClassNames = classnames("".concat(CSS_BLOCK, "__box"), (_classnames4 = {}, (0, _defineProperty2.default)(_classnames4, "".concat(CSS_BLOCK, "__box--inline"), isInline), (0, _defineProperty2.default)(_classnames4, "".concat(CSS_BLOCK, "__box--centered"), !isInline && !isBlock), _classnames4), boxClassName);
      return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, otherProps, {
        "aria-describedby": isInline ? null : "".concat(id || this.shortId, "-message"),
        "aria-label": isInline ? message : null,
        "aria-live": isFullPage || isFullScreen ? 'assertive' : 'polite',
        className: classes,
        id: id || this.shortId,
        ref: function ref(node) {
          _this2.spinner = node;
          _this2._handleFocusManager(isFullScreen);
        },
        role: isFullPage || isFullScreen ? 'alert' : 'status'
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: spinnerBoxClassNames
      }, this._renderSpinner(classnames, isInline, isFullScreen, isFullPage, message), this._renderMessaging(classnames, message, isInline, hideMessage, isFullPage, isFullScreen), isFullScreen && content ? /*#__PURE__*/_react.default.createElement("div", {
        className: classnames("".concat(CSS_BLOCK, "__content"), contentClassName)
      }, content) : null));
    }
  }]);
  return Spinner;
}(_react.default.Component);
Spinner.displayName = 'Spinner';
Spinner.propTypes = {
  /** The message that will be displayed/read to the user when the spinner is invoked. */
  message: _propTypes.default.string.isRequired,
  /** Custom classes to be added to the Spinner box’s wrapping `<div>`. */
  boxClassName: _propTypes.default.string,
  /** Custom classes to be added to the wrapping `<div>.` */
  className: _propTypes.default.string,
  /** Content to render under the spinner. */
  content: _propTypes.default.node,
  /** Custom classes to be added to the Spinner content’s wrapping `<div>`. */
  contentClassName: _propTypes.default.string,
  /** Hides the message text from view, but does not remove accessibility attributes.
   * **NOTE:** The `message` property is still required even if it will be hidden from
   * view to meet accessibility requirements. */
  hideMessage: _propTypes.default.bool,
  /** The DOM `id` of the spinner `<div>` element. If left blank, a random value will
   * be generated for accessibility purposes. */
  id: _propTypes.default.string,
  /** When true, the spinner will render with inverted colors and change the mask color
   * to `@brand-secondary` (for non-inline spinners). **NOTE:** To maintain consistency
   * across all of SAP Concur’s products, use the default spinner for most cases. */
  inverted: _propTypes.default.bool,
  /** The base color of the mask below the spinner. Options are `'gray'`, `'white'`. */
  maskColor: _propTypes.default.oneOf(MASK_COLORS),
  /** Custom classes to be added to the Spinner message `<p>` tag. */
  messageClassName: _propTypes.default.string,
  /** Custom classes to be added to the Spinner message’s wrapping `<div>`. */
  messageContainerClassName: _propTypes.default.string,
  /** Spinner size. Options are `'lg'`, `'md'`, `'sm'`. */
  size: _propTypes.default.oneOf(_StyleConfig.SPINNER_SIZES),
  /** Spinner type. Options are `'block'`, `'inline'`, `'fullPage'` and `'fullScreen'`. */
  type: _propTypes.default.oneOf(_StyleConfig.SPINNER_TYPES),
  /** Visibility of the spinner. Typically, a spinner is added for a component or page and
   * is not visible and gets set to visible when necessary. */
  visible: _propTypes.default.bool,
  /** Custom classes to be added to the underlying `<div>` that wraps the spinner svg. */
  wheelClassName: _propTypes.default.string
};
Spinner.defaultProps = {
  maskColor: 'gray',
  size: 'md'
};
var _default = (0, _reactUiTheming.withThemeStyles)(styles)(Spinner);
exports.default = _default;